import i18n from 'infrastructure/i18n';

import type { ISmsCampaignStatistic } from 'infrastructure/interfaces';

export const generateStatistics = (statistics: ISmsCampaignStatistic) => {
  let recipientsResponseRate = 0;
  if (statistics.total && statistics.completed) {
    recipientsResponseRate = Number(
      (statistics.completed / statistics.total) * 100,
    );
  }

  return [
    {
      label: i18n.t('labels.totalRecipients'),
      count: statistics.total,
    },
    {
      label: i18n.t('labels.campaignsSent'),
      count: statistics.sent,
    },
    {
      label: i18n.t('labels.campaignsPendingSending'),
      count: statistics.pending,
    },
    {
      label: i18n.t('labels.recipientsResponseRate'),
      count: `${recipientsResponseRate.toFixed(2)}%`,
    },
  ];
};
